import { NgModule } from '@angular/core';
import { CommonModule  } from '@angular/common';
import { CmxStatusIndicatorComponent, Statuses } from './components/';

@NgModule({
    declarations: [
        CmxStatusIndicatorComponent,
    ],
    exports: [
        CmxStatusIndicatorComponent,
    ],
    imports: [
        CommonModule,
    ],
})
export class CmxStatusIndicatorModule {
    constructor() {
        //
    }
}
